module.exports = __webpack_public_path__ + "media/site/images/voicetalents-slider/voicetalents_screens-08-30c46d26d24c67773393fcc1e3b05e1e.jpg";